
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import LastSync from '@/components/LastSync.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import moment from 'moment';
import DateRangeFilter from '@/components/reports-v3/components/filters/DateRangeFilter.vue';
import gdbx from '@/store/modules/gdbx';
import TotalRevenueNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpRevenueNumberDisplayer.vue';
import TotalCOGSNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpCogsNumberDisplayer.vue';
import TotalGrossProfitNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpGrossProfitNumberDisplayer.vue';
import TotalExpenseNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpExpensesNumberDisplayer.vue';
import NetProfitBeforeTaxNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpNetProfitBeforeTaxNumberDisplayer.vue';
import ProfitAndLostBarChart from '@/components/reports-v3/components/codedWidgets/bp/BpProfitLossBarChart.vue';
import SalesPurchaseExpenseBarChart from '@/components/reports-v3/components/codedWidgets/bp/BpRevenuePurchasesExpensesBarChart.vue';
import ExpensesTable from '@/components/reports-v3/components/codedWidgets/bp/BpExpensesTable.vue';
import COGSTable from '@/components/reports-v3/components/codedWidgets/bp/BpCostOfGoodsSoldTable.vue';
import TotalOtherIncomeNumberDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpOtherIncomeExtraOrdinaryIncomeNumberDisplayer.vue';
import accountx from '@/store/modules/accountx';
import ProjectSelectFilter from '@/components/reports-v3/components/filters/ProjectSelectFilter.vue';
import MonthToMonthComparison from '@/components/reports-v3/components/codedWidgets/bp/BpProfitLossMonthlyComparisonComparison.vue';

@Component({
	components: {
        MonthToMonthComparison,
        ProjectSelectFilter,
		TotalOtherIncomeNumberDisplayer,
		COGSTable,
		StickyFilterContainer,
		DateRangeFilter,
		LastSync,
		TotalRevenueNumberDisplayer,
		TotalCOGSNumberDisplayer,
		TotalGrossProfitNumberDisplayer,
		ProfitAndLostBarChart,
		TotalExpenseNumberDisplayer,
		NetProfitBeforeTaxNumberDisplayer,
		ExpensesTable,
		SalesPurchaseExpenseBarChart,
	},
})
export default class ProfitAndLoss extends Vue {
	public selectedDay: number = moment().endOf('day').valueOf();
	public selectedDateRange: [number, number] = gdbx.financialPeriodThisYear;

  public selectedProjects: string[] = [];

  public get selectedYearToDateRange(): [number, number] {
    return [
      moment(this.selectedDateRange[1]).add(-11, 'month').startOf('month').valueOf(),
      moment(this.selectedDateRange[1]).endOf('month').valueOf(),
    ];
  }

  public get getAccountId() {
    return accountx.currentAccountId;
  }

	public mounted() {
		this.track();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public get selectedAsOfDate() {
		return moment(this.selectedDay).endOf('month').valueOf();
	}

	public get selectedAgents() {
		return gdbx.allAgents;
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
